<style scoped>
    img {
        width:  400px;
        height: 166px;
        margin: auto;
        display: block;
    }
    .test {
        background-color: orange;
        width: 700px;
        height: 700px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .progress {
        width: 300px;
        height: 20px;
        margin: auto;
        display: block;
    }
</style>
<template>
    <div id='app-root' class="container-fluid">
        <div v-if="$root.IsLoading">
            <div class="col-sm-12">
                <br /><br /><br />
                <!--<div id="boxshadow">
                <div class="text-center" style="color:#6bd6b4;">
                    <h1>
                        <strong>VCARE</strong>
                    </h1>
                    <i class="fa fa-cog fa-spin fa-3x fa-fw text-center"></i>
                </div>
            </div>-->
                <!--<div id="over" style="position:absolute; width:100%; height:100%">-->
                <!--<div id="test">

                    <img class="displayed" src="../../Assets/splash_wide.png" alt="artist" />
                    <div class="progress progress-striped active">
                        <div class="progress-bar" style="width: 100%"></div>
                        
                    </div>
                </div>-->

            </div>
        </div>
        <div v-else>
            <div class="row">
                <div v-if="$root.IsCarehomeUser">
                    <menu-component />
                </div>
                <div v-else>
                    <PharmacyNavMenu />
                </div>
            </div>
            <div class="container">
                <div class="col-md-12">
                    <router-view></router-view>
                </div>
            </div>
        </div>
        <a v-shortkey="{ keys:'alt+/', title:'Shortcut Help', description:'Open shortcut help'}" @shortkey="OpenShortCutHelp"></a>
        <div class="modal" ref="shortcutModal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                        <h4 class="modal-title">Shortcuts</h4>
                    </div>
                    <div class="modal-body ">
                        <div class="row">
                            <div v-for="sc in shortcutData" class="col-sm-6">
                                <h4>{{sc.title}}</h4>
                                <table class="table table-striped">
                                    <tbody>
                                        <tr v-for="command in sc.commands">
                                            <td style="min-width:50px">{{GetSequence(command.keySequence)}}</td>
                                            <td>{{command.description}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal" v-shortkey="{keys:'escape', title: 'Shortcut Help', description:'Close Help'}" @shortkey="CloseHelp">Close</button>                        
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</template>
<script>
    import $ from 'jquery'
    import MenuComponent from '../navmenu/navmenu.vue.html'
    import PharmacyNavMenu from '../PharmacyNavMenu/PharmacyNavMenu.scp.html'

    export default {
        data: function () {
            return {
                shortcutData:[]
            }
        },
        methods: {
            CloseHelp() {

                $(this.$refs.shortcutModal).modal('toggle');
            },
            OpenShortCutHelp() {
                var sd = this.shortcuts();
                var titles = [];
                
                for (var item of sd) {
                    if (titles.indexOf(item.title) < 0) {
                        titles.push(item.title);
                    }
                }
                this.shortcutData = [];
                for (var title of titles) {
                    var commands = sd.filter(s => s.title == title);
                    this.shortcutData.push({ title: title, commands: commands });
                }
                console.log("showing shortcut help ", this.shortcutData)
                $(this.$refs.shortcutModal).modal('show');
            },
            GetSequence(sequence) {
                var result = "";
                for (var item of sequence) result = result + (result.length > 0 ? "," : "") + item;
                console.log(result, sequence)
                return result;
            }
        },
        components: {
            MenuComponent,
            PharmacyNavMenu
        }
    }
</script>


// WEBPACK FOOTER //
// AppLoader.scp.html?a969c446